import { Outlet, useParams } from "react-router";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Menu } from "../components/menu/menu.jsx";
import { MenuItem } from "../components/menu/menuItem.jsx";
import { EmployeesIcon, KnowledgeBaseIcon, ProfileIcon, ReportsIcon, TasksIcon } from "../assets/icons.jsx";
import { fetchAdminChecklistId, fetchCafes } from "../features/userReducer.js";
import { BackButton } from "../components/backButton/backButton.jsx";

export const AdminTemplate = () => {
    const dispatch = useDispatch();
    const { cafeId } = useParams();

    useEffect(() => {
        dispatch(fetchAdminChecklistId());
        dispatch(fetchCafes());
    }, [dispatch]);

    let menuItems = [];

    if (!cafeId) {
        menuItems = menuItems.concat([
            <MenuItem key="cafe" path="/admin" icon={<EmployeesIcon />} text="Предприятия" end />,
        ]);
    } else {
        menuItems = menuItems.concat([
            <MenuItem key="cafe" path={`/admin/${cafeId}/cafe`} icon={<EmployeesIcon />} text="Предприятие" />,
            <MenuItem key="reports" path={`/admin/${cafeId}/reports`} icon={<ReportsIcon />} text="Прогресс" />,
            <MenuItem key="tasks" path={`/admin/${cafeId}/tasks`} icon={<TasksIcon />} text="Задачи" />,
            <MenuItem key="knowledge" path={`/admin/${cafeId}/knowledge`} icon={<KnowledgeBaseIcon />} text="База знаний" />,
        ]);
    }

    menuItems.push(<MenuItem key="profile" path={cafeId ? `/admin/${cafeId}/profile` : "/admin/profile"} icon={<ProfileIcon />} text="Профиль" />);

    return (
        <div className="page_container">
            <div className="page_content">
                <BackButton minPathnameLength={4} stopRoutes={["materials", "tests"]} />
                <Outlet />
            </div>
            <Menu>
                {menuItems}
            </Menu>
        </div>
    )
}
